// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x6-8 {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 16px 16px;\n}\n\n.level-4 {\n  height: 24px;\n  width: 24px;\n}\n\n.beginner-6 {\n  margin-left: 12px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n@media only screen and (max-width: 600px) {\n  .level-4 {\n    height: 18px;\n    width: 18px;\n  }\n}", ""]);
// Exports
module.exports = exports;
